import { render, staticRenderFns } from "./CommodityReporting.vue?vue&type=template&id=5c9851c8&scoped=true"
import script from "./CommodityReporting.vue?vue&type=script&lang=js"
export * from "./CommodityReporting.vue?vue&type=script&lang=js"
import style0 from "./CommodityReporting.vue?vue&type=style&index=0&id=5c9851c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9851c8",
  null
  
)

export default component.exports